module.exports = __webpack_public_path__ + "static/img/poster2.cee487a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poster2.jpg
// module id = sJp5
// module chunks = 1